import React from 'react';
import { node } from 'prop-types';

import styles from './SinglePageLayout.scss';

function SinglePageLayout({ children, bottom }) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.up}>{children}</div>
        {bottom && <div className={styles.footer}>{bottom}</div>}
      </div>
    </div>
  );
}

SinglePageLayout.propTypes = {
  children: node.isRequired,
  bottom: node,
};

SinglePageLayout.defaultProps = {
  bottom: null,
};

export default SinglePageLayout;



// WEBPACK FOOTER //
// ./app/layouts/SinglePageLayout/SinglePageLayout.jsx